import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getActiveAlerts } from '../api/client'

const SEEN_KEY = 'seen_alerts'

function readSeen() {
  try { return new Set(JSON.parse(sessionStorage.getItem(SEEN_KEY) || '[]')) }
  catch { return new Set() }
}

function markSeen(id) {
  const seen = readSeen()
  seen.add(id)
  try { sessionStorage.setItem(SEEN_KEY, JSON.stringify([...seen])) } catch {}
}

export default function AlertModal() {
  const { t } = useTranslation(['settings'])
  const [queue, setQueue] = useState([])

  useEffect(() => {
    let cancelled = false
    getActiveAlerts()
      .then(list => {
        if (cancelled) return
        const seen = readSeen()
        setQueue((Array.isArray(list) ? list : []).filter(a => !seen.has(a.id)))
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  if (queue.length === 0) return null
  const current = queue[0]

  const dismiss = () => {
    markSeen(current.id)
    setQueue(q => q.slice(1))
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" onClick={dismiss} />
      <div className="relative bg-white rounded-2xl shadow-xl border border-gray-200 w-full max-w-md p-6">
        <h2 className="text-base font-semibold text-gray-900 mb-2">{current.title}</h2>
        {current.body && (
          <p className="text-sm text-gray-600 whitespace-pre-wrap mb-5">{current.body}</p>
        )}
        <button
          onClick={dismiss}
          className="w-full bg-gray-900 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-gray-700 transition-colors"
        >
          {t('alertPopup.gotIt')}
        </button>
      </div>
    </div>
  )
}
